<template >
  <div class="container-fluid">
    <form @submit.prevent="submit" >
      <div class="row">
        <div class="col-6 col-sm-6 col-md-6">
          <div class="form-group" v-if="errors.length" >
            <ul class="list-group">
              <li class="list-group-item list-group-item-danger" v-for="error in errors" :key="error">{{ error }}</li>
            </ul>
          </div>
          <div class="form-group input-group-sm">
            <label>Login</label>
            <input class="form-control" v-model="form.username"/>
          </div>
          <div class="form-group input-group-sm">
            <label>Hasło</label>
            <input class="form-control" v-model="form.password"/>
          </div>
          <div class="form-group form-check">
            <input class="form-check-input" type="checkbox" value="" id="enabledCheckId" v-model="form.enabled">
            <label class="form-check-label" for="enabledCheckId">
              Aktywny
            </label>
          </div>
          <div class="form-group input-group-sm">
            <label class="font-weight-bold">Sklep</label>
            <select class="form-control" v-model="form.storeId">
              <option v-for="option in stores" :key="option.id" v-bind:value="option.id">
                {{ option.name }}
              </option>
            </select>
          </div>
          <div class="form-group input-group-sm" v-for="userInfo in form.userData" :key="userInfo.key">
            <label>{{ userInfo.label }}</label>
            <input class="form-control" v-model="userInfo.value"/>
          </div>
          <div class="form-group input-group-sm">
            <label >Uprawnienia</label>
            <select multiple class="form-control select-size" v-model="form.permissions">
              <option v-for="option in permissions" :key="option.id" v-bind:value="option.id">
                {{ option.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="row ">
        <div class="col">
          <input class="btn btn-success btn-sm mr-2 torre-btn" type="submit" value="Zapisz">
          <router-link class="btn btn-secondary btn-sm" :to="{ name: 'users' }">Anuluj</router-link>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import userService from '@/service/userService'
import axios from 'axios'
import validator from 'validator'
import un from 'underscore'
import appConfig from '@/service/config'
import flashService from '@/service/flashService'
import base64 from 'base-64'
import MainPresenter from "@/service/MainPresenter"

export default {
  data: () => ({
    mainPresenter: new MainPresenter(),
    errors: [],
    permissions: [],
    stores: [
      {
        id: -1,
        name: "brak"
      }
    ],
    form: {
      username: "",
      password: "",
      enabled: true,
      storeId: -1,
      permissions: [],
      userData: [
        {
          key: "userName",
          value: "",
          label: "Imię"
        },
        {
          key: "userSurname",
          value: "",
          label: "Nazwisko"
        },
      ]
    }
  }),
  created() {
    this.loadPermissions();
    this.loadStores();
  },
  methods: {
    loadStores() {
      axios.get(this.mainPresenter.buildUrlWithDefaults("/allStores")).then(response => {
        this.stores = un.union(this.stores, response.data.content);
      }, err => {
        console.log(err.response);
        this.stores = [{id:0,name:"Error"}];
      })
    },
    stringContainsLatin: function(str) {
      try {
        base64.encode(str)
        return false
      } catch (e) {
        return true
      }
    },
    validate: function () {
      var err = []
      if (validator.isEmpty(this.form.username)) {
        err.push('podaj login')
      }
      if (this.stringContainsLatin(this.form.username)) {
        err.push('login nie może zawierać znaków typu: ąęść...')
      }
      if (validator.isEmpty(this.form.password)) {
        err.push('podaj hasło')
      }
      if (this.stringContainsLatin(this.form.password)) {
        err.push('hasło nie może zawierać znaków typu: ąęść...')
      }
      if (this.form.permissions.length === 0) {
        err.push('Wybierz uprawnienia')
      }
      un.each(this.form.userData, userData => {
        if (validator.isEmpty(userData.value)){
          err.push("podaj " + userData.label)
        }
      })
      return err
    },
    loadPermissions: function () {
      const req = axios({
        method: 'get',
        url: appConfig.baseUrl + '/userPermissions?sort=name',
        headers: {
          Authorization: userService.getAuthHeader()
        }
      })
      req.then(res => {
        this.permissions = res.data
      }).catch(e => {
        console.log(e)
      })
    },
    assignUserInfo: function () {
      var userInfo = {};
      un.each(this.form.userData, item => {
        userInfo[item.key] = item.value;
      });
      this.form.userInfo = userInfo;
    },
    submit: function() {
      var err = this.validate()
      if (err.length > 0) {
        this.errors = err
        return false
      }
      this.assignUserInfo();
      const req = axios({
        method: 'post',
        url: appConfig.baseUrl + '/users',
        data: this.form,
        headers: {
          Authorization: userService.getAuthHeader()
        }
      })
      req.then(res => {
        console.log(res.data)
        this.$router.push({name: 'users'})
      }).catch(err => {
        this.errors = un.map(err.response.data.errors, item => {
          return item.defaultMessage
        })
      })
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/users/UsersNew.vue